import { render, staticRenderFns } from "./ApiFunctionIndex.vue?vue&type=template&id=1fae71f8&"
import script from "./ApiFunctionIndex.vue?vue&type=script&lang=js&"
export * from "./ApiFunctionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports